import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  sidebarCollapsed: boolean;
  sidebarOpen: boolean; // For mobile drawer
  isMobile: boolean;
  darkMode: boolean;

  // Actions
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setSidebarOpen: (open: boolean) => void;
  setIsMobile: (isMobile: boolean) => void;
  toggleDarkMode: () => void;
  setDarkMode: (darkMode: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set, get) => ({
      sidebarCollapsed: false,
      sidebarOpen: false,
      isMobile: false,
      darkMode: false,

      toggleSidebar: () => {
        const state = get();
        if (state.isMobile) {
          set({ sidebarOpen: !state.sidebarOpen });
        } else {
          set({ sidebarCollapsed: !state.sidebarCollapsed });
        }
      },

      setSidebarCollapsed: (collapsed: boolean) => set({ sidebarCollapsed: collapsed }),
      setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
      setIsMobile: (isMobile: boolean) => set({ isMobile }),

      toggleDarkMode: () => {
        const newDarkMode = !get().darkMode;
        set({ darkMode: newDarkMode });
        // Update document class for Tailwind dark mode
        if (newDarkMode) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      },

      setDarkMode: (darkMode: boolean) => {
        set({ darkMode });
        // Update document class for Tailwind dark mode
        if (darkMode) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      },
    }),
    {
      name: 'ui-storage',
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        darkMode: state.darkMode
      }),
    }
  )
);
